import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["marginTopIndicator", "indicatorPosition"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import { ControlInputContainer } from '../../../internal/components/ControlInputContainer';
import { generateDataTestId } from '../../../internal/utils';
import { useDeviceType } from '../../../responsive';
import { useIsMultiLine } from './useIsMultiLine';
import { calculateMarginTopIndicator } from './utils';
import { getStyles } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var RadioComponent = /*#__PURE__*/React.forwardRef(function Radio(props, ref) {
  var deviceType = useDeviceType();
  var isMobile = deviceType === 'phone';
  var marginTopIndicator = props.marginTopIndicator,
    _props$indicatorPosit = props.indicatorPosition,
    indicatorPosition = _props$indicatorPosit === void 0 ? 'center' : _props$indicatorPosit,
    restProps = _objectWithoutProperties(props, _excluded);
  var disabled = restProps.disabled,
    invalid = restProps.invalid,
    label = restProps.label,
    dataTestId = restProps.dataTestId;
  var labelRef = React.useRef(null);
  var needCalculate = indicatorPosition === 'auto';
  var isMultiLine = useIsMultiLine(labelRef, needCalculate);
  var styles = getStyles(deviceType);
  var indicatorPositionIsTop = indicatorPosition === 'top' || indicatorPosition === 'auto' && isMultiLine;
  var marginTopIndicatorValue = calculateMarginTopIndicator({
    isMobile: isMobile,
    isMultiLine: isMultiLine,
    marginTopIndicator: marginTopIndicator,
    indicatorPosition: indicatorPosition
  });
  return /*#__PURE__*/_jsxs(ControlInputContainer, _objectSpread(_objectSpread({}, restProps), {}, {
    type: "radio",
    className: clsx(styles['radio'], disabled && styles['disabled'], invalid && styles['invalid'], !!label && styles['hasLabel']),
    ref: ref,
    children: [/*#__PURE__*/_jsx("span", {
      className: clsx(styles['indicator'], indicatorPositionIsTop && styles['indicator-top']),
      style: {
        top: "".concat(marginTopIndicatorValue, "px")
      }
    }), label && /*#__PURE__*/_jsx("span", {
      ref: labelRef,
      className: styles['label'],
      "data-testid": generateDataTestId(dataTestId, ['label']),
      children: label
    })]
  }));
});

/**
 * Компонент простого radio с лейблом
 *
 * На телефоне имеет блочный дизайн и radio справа
 *
 * @export
 * @param {IRadioProps} props
 * @returns
 */
export var Radio = /*#__PURE__*/React.memo(RadioComponent);